import React from 'react';
import {useState, useEffect} from "react";
import {useParams, Link, useNavigate} from 'react-router-dom';
import {
	getWeekReport,
	getProject,
	formatDate, 
	parseDateISOString, 
	getDateCaption
} from "./apiService";
import {
	getEntries as bigtimeGetEntries,
	addEntry as bigtimeAddEntry,
	deleteEntry as bigtimeDeleteEntry
} from "./bigtimeService"

const Week = (props) => {
	const [error, setError] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);
	const [sortedWeekReport, setSortedWeekReport] = useState([]);
	const [maxProjectLevel, setMaxProjectLevel] = useState(0);
	const [date, setDate] = useState(null);
	const [dayCount, setDayCount] = useState(7);
	const {dateParam} = useParams();
	const navigate = useNavigate();

	console.log('calling useEffect');
	useEffect(() => {
		console.log('Week useEffect', dateParam);
		let dateProp = dateParam;
		if(dateProp == null) {
			dateProp = formatDate(new Date());
			console.log('default date', dateProp);
		}
		let specifiedDate = parseDateISOString(dateProp);
		console.log('specifiedDate', specifiedDate);
		// find the beginning of the week
		let startOfWeek = new Date(specifiedDate.getTime());
		startOfWeek.setDate(specifiedDate.getDate() - specifiedDate.getDay());
		console.log('startOfWeek', startOfWeek);
		let firstOfNextMonth = new Date(startOfWeek.getTime());
		firstOfNextMonth.setMonth(firstOfNextMonth.getMonth() + 1, 1);
		console.log('firstOfNextMonth', firstOfNextMonth);
		let reportDate = startOfWeek;
		// get the number of days to the end of the month or 7 whichever is less
		let tmpDayCount = Math.round((firstOfNextMonth - startOfWeek) / (1000 * 60 * 60 * 24));
		if(tmpDayCount >= 7) {
			tmpDayCount = 7;
		}
		else {
			if(firstOfNextMonth.getTime() <= specifiedDate.getTime()) {
				reportDate = firstOfNextMonth;
				tmpDayCount = 7 - tmpDayCount;
			}
		}
		console.log('reportDate', reportDate);
		console.log('dayCount', tmpDayCount);
		setDayCount(tmpDayCount);
		setDate(reportDate);
		getWeekReport(formatDate(reportDate), tmpDayCount).then(
			data => {
				console.log('Week.useEffect getWeekReport data', data);
				if(data.status === 401) {
					navigate('/login', {replace: true});
					return;
				}
				if(data.status !== 200) {
					setIsLoaded(true);
					setError(data);
					return;
				}

				let maxProjectLevel = 0;
				for(let reportRow of data.result) {
					if(maxProjectLevel < reportRow.projects.length) {
						maxProjectLevel = reportRow.projects.length;
					}
				}

				setMaxProjectLevel(maxProjectLevel);
				console.log('maxProjectLevel', maxProjectLevel);
			
				let tmpSortedWeekReport = data.result.sort((row1, row2) => {
					for(let i = 0; i < maxProjectLevel; i++) {
						let projectCode1 = i < row1.projects.length ? row1.projects[i].code.toLowerCase() : '';
						let projectCode2 = i < row2.projects.length ? row2.projects[i].code.toLowerCase() : '';
						if(projectCode1 < projectCode2) {
							return -1;
						}
						if(projectCode1 > projectCode2) {
							return 1;
						}
					}
					return 0;
				});
			
				console.log('sortedWeekReport', tmpSortedWeekReport);
			
				setIsLoaded(true);
				setSortedWeekReport(tmpSortedWeekReport);
			},
			error => {
				console.log('error object', error);
				setIsLoaded(true);
				setError(error);
			}
		);
	}, [dateParam, navigate]);

	console.log('Week render', sortedWeekReport);

	if(error) {
		return <div>Error: {error.message}</div>;
	}

	if(!isLoaded) {
		return <div>Loading...</div>;
	}

	const projectColumns = reportRow => {
		let cols = [];
		for(let i = 0; i < maxProjectLevel; i++) {
			if(i >= reportRow.projects.length) {
				cols.push(<td key={i} className="project"></td>);
			}
			else {
				let project = reportRow.projects[i];
				cols.push(<td key={i} className="project">
					<Link to={`/projects/${project.id}`}>{project.code}</Link>
				</td>);
			}
		}
		return cols;
	};
	
	const pushChildCodes = (title, childCodes) => {
		if(childCodes) {
			if(typeof childCodes == 'object' && childCodes.constructor === Array) {
				for(let childCode of childCodes) {
					pushChildCodes(title, childCode);
				}
			}
			else {
				title.push(childCodes);
			}
		}
	};

	const getTitle = childCodes => {
		let title = [];
		pushChildCodes(title, childCodes);
		return title.join(', ');
	};

	const projectDurations = reportRow => {
		let durations = [];
		let totalDuration = 0;
		for(let i = 0; i < dayCount; i++) {
			let duration = reportRow.durations[i];
			totalDuration += duration;
			let title = reportRow.childCodes ? getTitle(reportRow.childCodes[i]) : '';
			durations.push(<td key={i} title={title} className="duration">{(duration / (1000 * 60 * 60)).toFixed(2)}</td>);
		}
		durations.push(<td key={8} className="duration">{(totalDuration / (1000 * 60 * 60)).toFixed(2)}</td>)
		return durations;
	};

	const getDate = delta => {
		let newDate = new Date(date);
		newDate.setDate(newDate.getDate() + delta);
		return newDate;
	};

	let nextDate = getDate(dayCount);
	let prevDate = getDate(dayCount < 7 ? dayCount - 7 : -7);

	let dayHeaders = [];
	for(let i = 0; i < dayCount; i++) {
		let newDate = getDate(i);
		dayHeaders.push(<td key={i} className="duration">
			<Link to={`/events/${formatDate(newDate)}`}>{formatDate(newDate)}</Link>
			</td>);
	}
	dayHeaders.push(<td key={8} className="duration">&nbsp;&nbsp;&nbsp;Total</td>);

	const newTotals = () => {
		let totals = [];
		for(let d = 0; d < dayCount; d++) {
			totals[d] = 0;
		}
		return totals;
	};

	const newChildCodes = () => {
		let childCodes = [];
		for(let d = 0; d < dayCount; d++) {
			childCodes[d] = [];
		}
		return childCodes;
	}

	const newProjectAccumulator = project => {
		return {
			code: project.code,
			id: project.id,
			totals: newTotals(),
			childCodes: newChildCodes(),
			count: 0,
			minDuration: project.minDuration,
			round: project.round,
			getProject: function() {
				return {
					code: this.code,
					id: this.id,
					minDuration: this.minDuration,
					round: this.round
				}
			},
			addReportRow: function(reportRow) {
				for(let d = 0; d < dayCount; d++) {
					let duration = reportRow.durations[d];
					if(duration !== 0) {
						if(reportRow.childCodes) {
							this.childCodes[d].push(reportRow.childCodes[d]);
						}
						else {
							let codes = [];
							let i = reportRow.projects.length - 1;
							while(i >= 0) {
								let project = reportRow.projects[i];
								console.log('project', project);
								let bigtimeProjectId = project.bigtimeProjectId || 0;
								let bigtimeTaskId = project.bigtimeTaskId || 0;
								let bigtimeDescription = project.bigtimeDescription || '';
								if(bigtimeProjectId !== 0 || bigtimeTaskId !== 0) {
									break;
								}
								codes.push(bigtimeDescription !== '' ? bigtimeDescription : project.code);
								i--;
							}
							let reverseCodes = [];
							for(let i = codes.length - 1; i >= 0; i--) {
								reverseCodes.push(codes[i]);
							}
							this.childCodes[d].push(reverseCodes.join(' '));
						}
					}
					this.totals[d] += duration;
				}
				this.count++;
			}
		}
	};

	let newAccumulator = (maxProjectLevel) => {
		let project = [];
		for(let i = 0; i < maxProjectLevel; i++) {
			project[i] = newProjectAccumulator({code: '', id: 0, minDuration: 0, round: 0});
		}
		return {
			project: project,
			getTotalRow: function(level) {
				let totalRow = {projects: [], durations: []};
				for(let i = 0; i <= level; i++) {
					totalRow.projects[i] = this.project[i].getProject();
				}
				let durations = this.project[level].totals;
				for(let i = 0; i < durations.length; i++) {
					totalRow.durations[i] = durations[i];
				}
				if(this.project[level].childCodes) {
					totalRow.childCodes = [];
					let childCodes = this.project[level].childCodes;
					for(let i = 0; i < durations.length; i++) {
						totalRow.childCodes[i] = childCodes[i];
					}
				}
				return totalRow;
			},
			isRounded: function(level) {
				return this.project[level].minDuration !== 0 || this.project[level].round !== 0
			},
			getRoundedTotalRow: function(level) {
				let totalRow = {projects: [], durations: [], childCodes: []};
				for(let i = 0; i <= level; i++) {
					totalRow.projects[i] = this.project[i].getProject();
				}
				let project = this.project[level];
				let durations = this.project[level].totals;
				let childCodes = this.project[level].childCodes;
				for(let i = 0; i < durations.length; i++) {
					let duration = durations[i];
					let minDuration = project.minDuration;
					if(minDuration !== 0) {
						if(duration > 0 && duration < minDuration) {
							duration = minDuration;
						}
					}
					let round = project.round;
					if(round !== 0) {
						duration = Math.ceil(duration / round) * round;
					}
					totalRow.durations[i] = duration;
					totalRow.childCodes[i] = childCodes[i];
				}
				return totalRow;
			}
		};
	};

	let expandedWeekReport = [];
	let roundedWeekReport = [];
	let accumulator = newAccumulator(maxProjectLevel);
	for(let reportRow of sortedWeekReport) {
		for(let i = maxProjectLevel - 1; i >= 0; i--) {
			let project = i < reportRow.projects.length 
				? reportRow.projects[i] 
				: {code: '', id: 0, minDuration: 0, round: 0};
			if(project.code !== accumulator.project[i].code) {
				if(accumulator.project[i].count > 0) {
					let totalRow = accumulator.getTotalRow(i);
					expandedWeekReport.push(totalRow);
					if(accumulator.isRounded(i)) {
						roundedWeekReport.push(accumulator.getRoundedTotalRow(i));
					}
				}
				accumulator.project[i] = newProjectAccumulator(project);
			}
			if(i < reportRow.projects.length) {
				accumulator.project[i].addReportRow(reportRow);
			}
		}
	}
	for(let i = maxProjectLevel - 1; i >= 0; i--) {
		if(accumulator.project[i].count > 0) {
			let totalRow = accumulator.getTotalRow(i);
			expandedWeekReport.push(totalRow);
			if(accumulator.isRounded(i)) {
				roundedWeekReport.push(accumulator.getRoundedTotalRow(i));
			}
		}
	}

	console.log('expandedWeekReport', expandedWeekReport);
	console.log('roundedWeekReport', roundedWeekReport);
	let expandedRoundedWeekReport = [];
	accumulator = newAccumulator(maxProjectLevel);
	for(let reportRow of roundedWeekReport) {
		for(let i = maxProjectLevel - 1; i >= 0; i--) {
			let project = i < reportRow.projects.length 
				? reportRow.projects[i] 
				: {code: '', id: 0, minDuration: 0, round: 0};
			if(project.code !== accumulator.project[i].code) {
				if(accumulator.project[i].count > 0) {
					let totalRow = accumulator.getTotalRow(i);
					expandedRoundedWeekReport.push(totalRow);
				}
				accumulator.project[i] = newProjectAccumulator(project);
			}
			if(i < reportRow.projects.length) {
				accumulator.project[i].addReportRow(reportRow);
			}
		}
	}
	for(let i = maxProjectLevel - 1; i >= 0; i--) {
		if(accumulator.project[i].count > 0) {
			let totalRow = accumulator.getTotalRow(i);
			expandedRoundedWeekReport.push(totalRow);
		}
	}

	const handleBigtime = e => {
		console.log('handleBigtime', date, dayCount);
		let token = window.localStorage.getItem('bigtime-token');
		console.log("bigtime token", token);
		if(token == null) {
			navigate('/bigtimeLogin', {replace: true});
		}
		let startDate = date;
		let endDate = new Date(startDate.valueOf());
		endDate.setDate(startDate.getDate() + dayCount - 1);
		enableBigtimeButton(false);
		bigtimeGetEntries(startDate, endDate).then(data => {
			console.log('bigtimeGetEntries data', data);
			let deleteEntry = index => {
				if(index >= data.length) {
					let projectTree = {};
					let processRow = rowIndex => {
						if(rowIndex >= expandedRoundedWeekReport.length) {
							enableBigtimeButton(true);
							return;
						}
						let row = expandedRoundedWeekReport[rowIndex];
						let leafProject = null;
						let tree = projectTree;
						for(let project of row.projects) {
							if(project.id === 0) {
								break;
							}
							leafProject = project;
							if(tree[project.id] == null) {
								tree[project.id] = {code: project.code, id: project.id, children: {}, days: []};
							}
							for(let i = 0; i < row.durations.length; i++) {
								let duration = row.durations[i];
								if(duration !== 0) {
									tree[project.id].days[i] = true;
								}
							}
							tree = tree[project.id].children;
						}
						getProject(leafProject.id).then(data => {
							console.log('getProject data', data);
							if(data.status !== 200) {
								debugger;
								processRow(rowIndex + 1);
								return;
							}
							let project = data.result;
							let staffSID = 368494;
							let projectSID = project.bigtimeProjectId || 0;
							let taskSID = project.bigtimeTaskId || 0;
							if(projectSID === 0 || taskSID === 0) {
								processRow(rowIndex + 1);
								return;
							}
							let processDay = dayIndex => {
								if(dayIndex >= row.durations.length) {
									processRow(rowIndex + 1);
									return;
								}
								let workDate = getDate(dayIndex);
								let duration = row.durations[dayIndex];
								if(duration === 0) {
									processDay(dayIndex + 1);
									return;
								}
								let hours = duration / (1000 * 60 * 60);
								let notes = row.childCodes ? getTitle(row.childCodes[dayIndex]) : '';
								bigtimeAddEntry(staffSID, projectSID, taskSID, workDate, hours, notes).then(data => {
									console.log('bigtimeAddEntry data', data);
									processDay(dayIndex + 1);
								});
							};
							processDay(0);
						});
					};
					processRow(0);
					return;
				}
				let entry = data[index];
				let sid = entry.SID;
				if(sid >= 0) {
				  deleteEntry(index + 1);
				  return;
				}
				bigtimeDeleteEntry(sid).then(data => {
					console.log('bigtime deleteEntry data', data);
					deleteEntry(index + 1);
				});
			};
			deleteEntry(0);
		},
		error => {
			console.log('error object', error);
			if(error && error.status && error.status === 401) {
				navigate('/bigtimeLogin', {replace: true});
			}
			else {
				setIsLoaded(true);
				setError(error);
			}
		});
	};

	const enableBigtimeButton = enabled => {
		let button = document.getElementById('bigtimeButton');
		if(button) {
			button.disabled = !enabled;
		}
	}
	enableBigtimeButton(true);

	return (
		<>
		<table className="week">
		<thead>
			<tr>
				<td colSpan={maxProjectLevel}>
				<Link to={`/week/${formatDate(prevDate)}`}>{getDateCaption(prevDate)}</Link> &nbsp;
				<Link to={`/week/${formatDate(nextDate)}`}>{getDateCaption(nextDate)}</Link>
				</td>
				{ dayHeaders }
			</tr>
		</thead>
		<tbody>
		{
			expandedWeekReport.map(reportRow => {
	 			return (
					<tr key={JSON.stringify(reportRow)}>
						{projectColumns(reportRow)}
						{projectDurations(reportRow)}
					</tr>
				);
			})
		}
		</tbody>
		<thead>
			<tr>
				<td colSpan={maxProjectLevel}></td>
				{dayHeaders}
			</tr>
			
		</thead>
		<tbody>
		{
			expandedRoundedWeekReport.map(reportRow => {
				return (
					<tr key={JSON.stringify(reportRow)}>
						{projectColumns(reportRow)}
						{projectDurations(reportRow)}
					</tr>
				)
			})
		}
		</tbody>
		</table>
		<button type="button" onClick={handleBigtime} id="bigtimeButton">Bigtime</button>

		</>
	);
};

export default Week;